import { JSX, StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ConfigurationService } from '../../../services/configuration.service';
import LoggedOff from '../LoggedOff';
import MunicipalityAdministrator from './index';
import RegisterScore from '../Shared/RegisterScore';
import Participation from './components/Participation';
import EditParticipation from '../Shared/EditParticipation';
import AccessDenied from '../AccessDenied';
import EditSchool from './EditSchool';
import Municipality from './components/Municipality';
// ToDo: NV-6449 gör komponent delad
import RegisterInCompetition from '../Shared/RegisterInCompetition';
import { Role } from '../../../models/pa-egna-ben/role.enum';
import AddTeacher from '../Shared/AddTeacher';
import MyInformation from '../Shared/MyInformation';
import DeleteAccount from '../Shared/DeleteAccount';
import NotFoundRedirect from '../Shared/NotFoundRedirect';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <MunicipalityAdministrator />,
    },
    {
      path: '/session-utgangen',
      element: (
        <LoggedOff
          headingText="Du har blivit utloggad"
          bodyText="För att skydda dina uppgifter loggas du automatiskt ut efter en tids inaktivitet. Logga in igen för att fortsätta använda tjänsten."
        />
      ),
    },
    {
      path: '/kommuner/:municipalityGid',
      element: <Municipality />,
    },
    {
      path: '/kommuner/:municipalityGid/anmalning',
      element: <RegisterInCompetition role={Role.municipalityAdministrator} />,
    },
    {
      path: '/klasser/:participationId/etapp/:legNumber/rapportera-poang',
      element: <RegisterScore viewerRole={Role.municipalityAdministrator} />,
    },
    {
      path: '/atkomst-saknas',
      element: <AccessDenied />,
    },
    {
      path: '/skolor/lagg-till',
      element: <EditSchool />,
    },
    {
      path: '/skolor/:schoolId',
      element: <EditSchool />,
    },
    {
      path: '/klasser/:participationId',
      element: <Participation />,
    },
    {
      path: '/klasser/:participationId/klassuppgifter',
      element: <EditParticipation viewerRole={Role.municipalityAdministrator} />,
    },
    {
      path: '/klasser/:participationId/lagg-till-pedagog',
      element: <AddTeacher viewerRole={Role.municipalityAdministrator} />,
    },
    {
      path: '/mina-uppgifter',
      element: <MyInformation viewerRole={Role.municipalityAdministrator} />,
    },
    {
      path: '/avsluta-konto',
      element: <DeleteAccount role={Role.municipalityAdministrator} />,
    },
    {
      path: '*',
      element: <NotFoundRedirect />,
    },
  ],
  { basename: ConfigurationService.get('paegnaben.municipalityadministratorpage.basename') }
);

export default function createRouterProvider(): JSX.Element {
  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
